export const ID_CARDS_FETCHING = 'ID_CARDS_FETCHING';
export const ID_CARDS_FETCH_ERROR = 'ID_CARDS_FETCH_ERROR';
export const ID_CARDS_GET_DATA = 'ID_CARDS_GET_DATA';
export const ID_CARDS_GET_REPORT = 'ID_CARDS_GET_REPORT';
export const ID_CARDS_CLEAR_REPORT = 'ID_CARDS_CLEAR_REPORT';
export const ID_CARDS_CLEAR_ERRORS = 'ID_CARDS_CLEAR_ERRORS';
export const ID_CARDS_FETCH_GRADES = 'ID_CARDS_FETCH_GRADES';



// WEBPACK FOOTER //
// ./src/pages/idcards/state/idcards/types.js